/**
 * Detect iOS / Android in-app browsers (Instagram, Facebook, TikTok, etc.)
 * where fixed positioning, GIS, and touch/click behavior often break.
 */
export function isInAppBrowser(ua = typeof navigator !== "undefined" ? navigator.userAgent : ""): boolean {
  return /Instagram|FBAN|FBAV|FBIOS|FB_IAB|Line\/|Twitter|TikTok|Bytedance|musical_ly|Snapchat|MicroMessenger|LinkedInApp|Pinterest|GSA\//i.test(
    ua
  );
}

export function isIOS(ua = typeof navigator !== "undefined" ? navigator.userAgent : ""): boolean {
  const iOSDevice = /iPad|iPhone|iPod/i.test(ua);
  const iPadOS = typeof navigator !== "undefined" && navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1;
  return (iOSDevice || iPadOS) && !(typeof window !== "undefined" && "MSStream" in window);
}

/** Instagram / Facebook / TikTok WKWebView on iPhone — the environment that breaks our header + filters. */
export function isIOSInAppBrowser(ua = typeof navigator !== "undefined" ? navigator.userAgent : ""): boolean {
  if (!isIOS(ua)) return false;
  if (isInAppBrowser(ua)) return true;
  // Generic WKWebView: iOS UA without Safari token (and not Chrome/Firefox iOS)
  const hasSafari = /Safari/i.test(ua);
  const isCriOS = /CriOS|FxiOS|EdgiOS/i.test(ua);
  return !hasSafari && !isCriOS;
}
